export default () => {
	function navigation(slider) {
		let wrapper, arrowLeft, arrowRight;

		function markup(remove) {
			wrapperMarkup(remove);
			arrowMarkup(remove);
		}

		function removeElement(elment) {
			elment.parentNode.removeChild(elment);
		}

		function createDiv(className) {
			const div = document.createElement('div');
			const classNames = className.split(' ');
			classNames.forEach((name) => div.classList.add(name));
			return div;
		}

		function arrowMarkup(remove) {
			if (remove) {
				removeElement(arrowLeft);
				removeElement(arrowRight);
				return;
			}
			arrowLeft = createDiv('hd-Navigation_Arrow hd-Navigation_Arrow-left');
			arrowLeft.addEventListener('click', () => slider.prev());
			arrowRight = createDiv('hd-Navigation_Arrow hd-Navigation_Arrow-right');
			arrowRight.addEventListener('click', () => slider.next());

			wrapper.appendChild(arrowLeft);
			wrapper.appendChild(arrowRight);
		}

		function wrapperMarkup(remove) {
			if (remove) {
				const parent = wrapper.parentNode;
				while (wrapper.firstChild)
					parent.insertBefore(wrapper.firstChild, wrapper);
				removeElement(wrapper);
				return;
			}
			wrapper = createDiv('hd-Navigation_Wrapper');
			slider.container.parentNode.appendChild(wrapper);
			wrapper.appendChild(slider.container);
		}

		function updateClasses() {
			const { rel: slide, maxIdx: last } = slider.track.details;

			if (slide === 0) {
				arrowLeft.classList.add('hd-Navigation_Arrow-disabled');
				arrowRight.classList.remove('hd-Navigation_Arrow-disabled');
			}

			if (slide === last) {
				arrowRight.classList.add('hd-Navigation_Arrow-disabled');
				arrowLeft.classList.remove('hd-Navigation_Arrow-disabled');
			}
		}

		slider.on('created', () => {
			markup();
			updateClasses();
		});
		slider.on('optionsChanged', () => {
			markup(true);
			markup();
			updateClasses();
		});
		slider.on('slideChanged', () => {
			updateClasses();
		});
		slider.on('destroyed', () => {
			markup(true);
		});
	}

	const sliders = document.querySelectorAll('.js-keen-slider');

	if ('KeenSlider' in window) {
		sliders.forEach(el => {
			const slidesPerView = Number(el.dataset.slidesPerView) || 3;
			const spacing = Number(el.dataset.spacing) || 10;

			const s = new KeenSlider(el, {
				slides: {
					perView: slidesPerView,
					spacing: spacing,
					sideOffset: 15,
				},
			}, [navigation]);
		});
	}
}
